import React, { Fragment } from "react";
import { Card } from "react-bootstrap";
import _ from "lodash";

import QualificationFrom from "./QualificationForm";
import OrganizationDetailsForm from "./OrganizationDetailsForm";
import { QUALIFICATION_TYPES } from "../../../../../constants/constants";
import { getQualificationDetails } from "../../../../../util/onBoardingDataFilters";

const EducationAndProfessionalExperience = ({
  personalDetails,
  states,
  updatePersonalDetails
}) => {
  const handleOnChangePersonalDetails = (
    { target: { name, value } },
    objectName,
    id
  ) => {
    updatePersonalDetails(name, value, objectName, id);
  };
  const isPostGraduation = !_.isEmpty(
    getQualificationDetails(
      QUALIFICATION_TYPES.POSTGRADUATION,
      personalDetails.qualifications
    )
  );
  return (
    <Fragment>
      <Card className="mt-2">
        <Card.Header>Educational Details</Card.Header>
        <Card.Body>
          <h6>X Std</h6>
          <QualificationFrom
            qualificationTypeId={"CLASSX"}
            qualificationDetails={getQualificationDetails(
              QUALIFICATION_TYPES.CLASSX,
              personalDetails.qualifications
            )}
            states={states}
            handleOnChangePersonalDetails={handleOnChangePersonalDetails}
          />
          <h6>XII Std/Equiv</h6>
          <QualificationFrom
            qualificationTypeId={"CLASSXII"}
            qualificationDetails={getQualificationDetails(
              QUALIFICATION_TYPES.CLASSXII,
              personalDetails.qualifications
            )}
            states={states}
            handleOnChangePersonalDetails={handleOnChangePersonalDetails}
          />
          <h6>Graduate</h6>
          <QualificationFrom
            qualificationTypeId={"GRADUATION"}
            qualificationDetails={getQualificationDetails(
              QUALIFICATION_TYPES.GRADUATION,
              personalDetails.qualifications
            )}
            states={states}
            handleOnChangePersonalDetails={handleOnChangePersonalDetails}
          />
          {isPostGraduation && (
            <Fragment>
              <h6>PG (if any)</h6>
              <QualificationFrom
                qualificationTypeId={"POSTGRADUATION"}
                qualificationDetails={getQualificationDetails(
                  QUALIFICATION_TYPES.POSTGRADUATION,
                  personalDetails.qualifications
                )}
                states={states}
                handleOnChangePersonalDetails={handleOnChangePersonalDetails}
              />
            </Fragment>
          )}
        </Card.Body>
      </Card>
      {personalDetails.organizationDetails?.length !== 0 && (
        <Card className="mt-2">
          <Card.Header>Professional Experience</Card.Header>
          <Card.Body>
            <h6>Last 3 Full Time Employment Details (begin with latest)</h6>
            {_.orderBy(
              personalDetails.organizationDetails,
              "lastWorkingDate",
              "desc"
            ).map(organization => (
              <OrganizationDetailsForm
                organization={organization}
                handleOnChangePersonalDetails={handleOnChangePersonalDetails}
              />
            ))}
          </Card.Body>
        </Card>
      )}
    </Fragment>
  );
};

export default EducationAndProfessionalExperience;
